<div>
  <div *ngFor="let dt of dataList;let i = index" class="md-radio" [ngClass]="isInline?'md-radio-inline':''">
    <input id="{{i}}" type="radio" name="listName" checked (change)="selectOption($event,dt)">
    <label for="{{i}}">{{dt.value}}</label>
  </div>
</div>
